import {CSSProperties, FC} from 'react';


export interface IIconTradeInBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconTradeInBmw: FC<IIconTradeInBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M6.244 12.22c0-3.5 2.691-6.11 6-6.11 1.553 0 2.965.542 4.031 1.514l-2.031 2.114.4.482H20V4.4l-.278-.4-2.094 2.155c-1.43-1.332-3.311-2.045-5.415-2.045-4.41 0-7.969 3.61-7.969 8.11h2Zm13.756 0V12c0 4.411-3.467 8-7.878 8-2.104 0-3.954-.823-5.384-2.156L4.491 20 4 19.6v-5.38h5.844l.4.29-2.031 1.976c1.066.971 2.356 1.541 3.909 1.541 3.309 0 5.878-2.718 5.878-6.026v.219h2Z" clipRule="evenodd" />
        </svg>
    );
};
